<template>
    <AppLayout>

        <!-- Banner  -->
        <div class="container-fluid mb-5" id="profile-header-section">
            <div class="container">
                <div class="row align-items-center">
                    <!-- <div class="col-md-3 text-center">
                        <div class="profile-avatar">
                            <img src="/images/tafara.JPG" alt="Profile Picture" class="rounded-circle mb-3">
                            <button class="btn btn-sm btn-outline-primary d-none">Change Photo</button>
                        </div>
                    </div> -->
                    <div class="col-md-9">
                        <div class="profile-info">
                            <h2 class="mb-2">{{ user.first_name }} {{ user.last_name }}</h2>
                            <p class="text-muted mb-2">{{ user.professional_title }}</p>
                            <!-- <div class="profile-badges mb-3">
                                <span class="badge bg-primary me-2">Professional Member</span>
                                <span class="badge bg-success me-2">GDPR Certified</span>
                                <span class="badge bg-info">ISO 27001 Expert</span>
                            </div>
                            <div class="profile-stats d-flex d-none">
                                <div class="stat-item me-4">
                                    <strong>0</strong>
                                    <small class="text-muted d-block">CPD Hours</small>
                                </div>
                                <div class="stat-item me-4">
                                    <strong>1</strong>
                                    <small class="text-muted d-block">Certificates</small>
                                </div>
                                <div class="stat-item">
                                    <strong>3</strong>
                                    <small class="text-muted d-block">Years Experience</small>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Content -->
        <div class="container">


            <div class="row mt-4">
                <!-- Personal Information -->
                <div class="col-md-8">
                    <div class="card mb-4">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Personal Information</h5>
                            <div>
                                <button v-if="!isEditMode" @click="toggleEditMode" class="btn btn-sm btn-outline-primary">
                                    <i class="bi bi-pencil me-1"></i>Edit
                                </button>
                                <div v-else>
                                    <button @click="toggleEditMode" class="btn btn-sm btn-outline-secondary me-2">
                                        Cancel
                                    </button>
                                    <button @click="updateProfile" :disabled="form.processing" class="btn btn-sm btn-primary">
                                        <span v-if="form.processing">
                                            <i class="bi bi-arrow-repeat spinning me-1"></i>Saving...
                                        </span>
                                        <span v-else>
                                            <i class="bi bi-check me-1"></i>Save
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <form @submit.prevent="updateProfile">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="firstName" class="form-label">First Name</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': form.errors.first_name }" id="firstName" v-model="form.first_name" :readonly="!isEditMode">
                                        <div v-if="form.errors.first_name" class="invalid-feedback">
                                            {{ form.errors.first_name }}
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="lastName" class="form-label">Last Name</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': form.errors.last_name }" id="lastName" v-model="form.last_name" :readonly="!isEditMode">
                                        <div v-if="form.errors.last_name" class="invalid-feedback">
                                            {{ form.errors.last_name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="email" class="form-label">Email Address</label>
                                        <input type="email" class="form-control" id="email" :value="user.email" readonly>
                                        <small class="text-muted">Email cannot be changed</small>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="phone" class="form-label">Phone Number</label>
                                        <input type="tel" class="form-control" :class="{ 'is-invalid': form.errors.phone }" id="phone" v-model="form.phone" :readonly="!isEditMode">
                                        <div v-if="form.errors.phone" class="invalid-feedback">
                                            {{ form.errors.phone }}
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="jobTitle" class="form-label">Professional Title</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': form.errors.professional_title }" id="jobTitle" v-model="form.professional_title" :readonly="!isEditMode">
                                        <div v-if="form.errors.professional_title" class="invalid-feedback">
                                            {{ form.errors.professional_title }}
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="company" class="form-label">Company</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': form.errors.company }" id="company" v-model="form.company" :readonly="!isEditMode">
                                        <div v-if="form.errors.company" class="invalid-feedback">
                                            {{ form.errors.company }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="bio" class="form-label">Professional Bio</label>
                                    <textarea class="form-control" :class="{ 'is-invalid': form.errors.bio }" id="bio" rows="8" v-model="form.bio" :readonly="!isEditMode"></textarea>
                                    <div v-if="form.errors.bio" class="invalid-feedback">
                                        {{ form.errors.bio }}
                                    </div>
                                </div>


                            </form>
                        </div>
                    </div>

                    <!-- Certifications & Skills -->
                    <div v-if="!showCertificationForm" class="card mb-4" id="certs_and_skills">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Certifications & Skills</h5>
                            <button @click="openAddCertificationForm" class="btn btn-sm btn-outline-success">
                                <i class="bi bi-plus-circle me-1"></i>Add Certification
                            </button>

                        </div>
                        <div class="card-body">
                            <!-- Certifications -->
                            <h6 class="mb-3">Professional Certifications</h6>

                            <!-- Dynamic Certifications -->
                            <div v-if="certifications && certifications.length > 0" class="certification-grid mb-4">
                                <div v-for="certification in certifications" :key="certification.id" class="certification-item">
                                    <div class="cert-icon" :class="`bg-${certification.color || 'primary'}`">
                                        <i :class="certification.icon_class || 'bi bi-award'"></i>
                                    </div>
                                    <div class="cert-details">
                                        <h6 class="mb-1">{{ certification.name }}</h6>
                                        <small class="text-muted">{{ certification.full_name || certification.issuing_organization }}</small>
                                        <p class="text-muted small mb-1">{{ certification.issuing_organization }}</p>
                                        <div class="cert-date text-success">
                                            <span v-if="certification.expiry_date">Valid until: {{ formatDate(certification.expiry_date) }}</span>
                                            <span v-else>Lifetime Certification</span>
                                        </div>
                                        <div class="cert-actions mt-2">
                                            <button @click="editCertification(certification)" class="btn btn-sm btn-outline-primary me-2">
                                                <i class="bi bi-pencil"></i> Edit
                                            </button>
                                            <button @click="deleteCertification(certification.id)" class="btn btn-sm btn-outline-danger">
                                                <i class="bi bi-trash"></i> Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Empty State -->
                            <div v-else class="text-center py-4">
                                <i class="bi bi-award text-muted" style="font-size: 3rem;"></i>
                                <h6 class="text-muted mt-2">No Certifications Added</h6>
                                <p class="text-muted small">Add your professional certifications to showcase your expertise</p>
                                <button @click="openAddCertificationForm" class="btn btn-success btn-sm">
                                    <i class="bi bi-plus-circle me-1"></i>Add Your First Certification
                                </button>
                            </div>

                            <!-- Skills -->
                            <h6 class="mb-3 d-none">Professional Skills</h6>
                            <div class="skills-container d-none">
                                <div class="skill-item">
                                    <div class="d-flex justify-content-between mb-1">
                                        <span>Risk Assessment</span>
                                        <span>90%</span>
                                    </div>
                                    <div class="progress mb-2" style="height: 6px;">
                                        <div class="progress-bar bg-primary" style="width: 90%"></div>
                                    </div>
                                </div>

                                <div class="skill-item">
                                    <div class="d-flex justify-content-between mb-1">
                                        <span>GDPR Compliance</span>
                                        <span>95%</span>
                                    </div>
                                    <div class="progress mb-2" style="height: 6px;">
                                        <div class="progress-bar bg-success" style="width: 95%"></div>
                                    </div>
                                </div>

                                <div class="skill-item">
                                    <div class="d-flex justify-content-between mb-1">
                                        <span>Incident Response</span>
                                        <span>85%</span>
                                    </div>
                                    <div class="progress mb-2" style="height: 6px;">
                                        <div class="progress-bar bg-warning" style="width: 85%"></div>
                                    </div>
                                </div>

                                <div class="skill-item">
                                    <div class="d-flex justify-content-between mb-1">
                                        <span>Security Architecture</span>
                                        <span>80%</span>
                                    </div>
                                    <div class="progress mb-2" style="height: 6px;">
                                        <div class="progress-bar bg-info" style="width: 80%"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Certification Form Card (replaces #certs_and_skills when adding/editing) -->
                    <div v-if="showCertificationForm" class="card mb-4" id="certification_form_card">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">
                                {{ isEditingCertification ? 'Edit Certification' : 'Add New Certification' }}
                            </h5>
                            <button type="button" class="btn-close" @click="closeCertificationForm" aria-label="Close"></button>
                        </div>
                        <div class="card-body">
                            <form @submit.prevent="saveCertification">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="certName" class="form-label">Certification Name</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': certificationForm.errors.name }" id="certName" v-model="certificationForm.name" placeholder="e.g., CISSP, CISA, ISO 27001">
                                        <div v-if="certificationForm.errors.name" class="invalid-feedback">
                                            {{ certificationForm.errors.name }}
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="fullName" class="form-label">Full Certification Name</label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': certificationForm.errors.full_name }" id="fullName" v-model="certificationForm.full_name" placeholder="e.g., Certified Information Systems Security Professional">
                                        <div v-if="certificationForm.errors.full_name" class="invalid-feedback">
                                            {{ certificationForm.errors.full_name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="issuingOrganization" class="form-label">Issuing Organization</label>
                                    <input type="text" class="form-control" :class="{ 'is-invalid': certificationForm.errors.issuing_organization }" id="issuingOrganization" v-model="certificationForm.issuing_organization" placeholder="e.g., (ISC)², ISACA">
                                    <div v-if="certificationForm.errors.issuing_organization" class="invalid-feedback">
                                        {{ certificationForm.errors.issuing_organization }}
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="issuedDate" class="form-label">Issue Date</label>
                                        <input type="date" class="form-control" :class="{ 'is-invalid': certificationForm.errors.issued_date }" id="issuedDate" v-model="certificationForm.issued_date">
                                        <div v-if="certificationForm.errors.issued_date" class="invalid-feedback">
                                            {{ certificationForm.errors.issued_date }}
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="expiryDate" class="form-label">Expiry Date</label>
                                        <input type="date" class="form-control" :class="{ 'is-invalid': certificationForm.errors.expiry_date }" id="expiryDate" v-model="certificationForm.expiry_date">
                                        <div v-if="certificationForm.errors.expiry_date" class="invalid-feedback">
                                            {{ certificationForm.errors.expiry_date }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="certificationNumber" class="form-label">Certification Number (Optional)</label>
                                    <input type="text" class="form-control" :class="{ 'is-invalid': certificationForm.errors.certification_number }" id="certificationNumber" v-model="certificationForm.certification_number" placeholder="Enter credential/license ID">
                                    <div v-if="certificationForm.errors.certification_number" class="invalid-feedback">
                                        {{ certificationForm.errors.certification_number }}
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="certDescription" class="form-label">Description (Optional)</label>
                                    <textarea class="form-control" :class="{ 'is-invalid': certificationForm.errors.description }" id="certDescription" v-model="certificationForm.description" rows="3" placeholder="Brief description of the certification"></textarea>
                                    <div v-if="certificationForm.errors.description" class="invalid-feedback">
                                        {{ certificationForm.errors.description }}
                                    </div>
                                </div>

                                <!-- Templates Section -->
                                <div class="mt-4" v-if="certificationTemplates.length > 0">
                                    <h6 class="mb-3">Quick Templates</h6>
                                    <div class="row">
                                        <div v-for="template in certificationTemplates" :key="template.id" class="col-md-6 mb-2">
                                            <div class="card template-card" @click="applyCertificationTemplate(template)">
                                                <div class="card-body p-2">
                                                    <div class="d-flex align-items-center">
                                                        <div class="template-icon me-2">
                                                            <i :class="template.icon" :style="`color: ${template.color}`"></i>
                                                        </div>
                                                        <div>
                                                            <h6 class="mb-0 small">{{ template.name }}</h6>
                                                            <small class="text-muted">{{ template.organization }}</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Form Actions -->
                                <div class="d-flex justify-content-end gap-2 mt-4">
                                    <button type="button" class="btn btn-secondary" @click="closeCertificationForm">
                                        <i class="bi bi-x-circle me-1"></i>Cancel
                                    </button>
                                    <button type="submit" :disabled="certificationForm.processing" class="btn btn-primary">
                                        <span v-if="certificationForm.processing">
                                            <i class="bi bi-arrow-repeat spinning me-1"></i>Saving...
                                        </span>
                                        <span v-else>
                                            <i class="bi bi-check me-1"></i>{{ isEditingCertification ? 'Update' : 'Save' }}
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>


                </div>

                <!-- Sidebar -->
                <div class="col-md-4">
                    <!-- CV/Resume Upload -->
                    <div class="card mb-4 d-none">
                        <div class="card-header">
                            <h5 class="mb-0">CV/Resume</h5>
                        </div>
                        <div class="card-body text-center">
                            <div class="cv-upload-area">
                                <i class="bi bi-file-earmark-text mb-3" style="font-size: 3rem; color: #6c757d;"></i>
                                <h6>Current CV</h6>
                                <p class="text-muted small">Keith_Terry_CV_2025.pdf</p>
                                <p class="text-muted small">Uploaded: Sep 15, 2025</p>
                                <div class="d-grid gap-2">
                                    <button class="btn btn-primary btn-sm">
                                        <i class="bi bi-download me-2"></i>Download
                                    </button>
                                    <button class="btn btn-outline-primary btn-sm">
                                        <i class="bi bi-upload me-2"></i>Update CV
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Password Change Section -->
                    <div class="card mb-4">
                        <div class="card-header">
                            <h5 class="mb-0">Change Password</h5>
                        </div>
                        <div class="card-body">
                            <!-- Security tip -->
                            <div class="alert alert-info mb-3">
                                <i class="bi bi-info-circle me-2"></i>
                                <strong>Security Tip:</strong> Use a strong password with at least 8 characters, including numbers, letters, and special characters.
                            </div>

                            <form @submit.prevent="updatePassword">
                                <div class="mb-3">
                                    <label for="currentPassword" class="form-label">Current Password</label>
                                    <input type="password" class="form-control" :class="{ 'is-invalid': passwordForm.errors.current_password }" id="currentPassword" v-model="passwordForm.current_password" placeholder="Enter your current password">
                                    <div v-if="passwordForm.errors.current_password" class="invalid-feedback">
                                        {{ passwordForm.errors.current_password }}
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label for="newPassword" class="form-label">New Password</label>
                                    <input type="password" class="form-control" :class="{ 'is-invalid': passwordForm.errors.password }" id="newPassword" v-model="passwordForm.password" placeholder="Enter new password (min. 8 characters)">

                                    <!-- Password Strength Indicator -->
                                    <div v-if="passwordForm.password" class="mt-2">
                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                            <small class="text-muted">Password Strength:</small>
                                            <small :class="`text-${passwordStrength.color}`" class="fw-bold">
                                                {{ passwordStrength.text }}
                                            </small>
                                        </div>
                                        <div class="progress" style="height: 4px;">
                                            <div class="progress-bar" :class="`bg-${passwordStrength.color}`" :style="`width: ${(passwordStrength.strength / 5) * 100}%`"></div>
                                        </div>
                                        <div class="mt-1">
                                            <small class="text-muted">
                                                Requirements: 8+ chars, lowercase, uppercase, numbers, symbols
                                            </small>
                                        </div>
                                    </div>

                                    <div v-if="passwordForm.errors.password" class="invalid-feedback">
                                        {{ passwordForm.errors.password }}
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label for="confirmPassword" class="form-label">Confirm New Password</label>
                                    <input type="password" class="form-control" :class="{
                                        'is-invalid': passwordForm.errors.password_confirmation,
                                        'is-valid': passwordForm.password_confirmation && passwordForm.password === passwordForm.password_confirmation && passwordForm.password.length >= 8
                                    }" id="confirmPassword" v-model="passwordForm.password_confirmation" placeholder="Confirm your new password">

                                    <!-- Password Match Indicator -->
                                    <div v-if="passwordForm.password_confirmation" class="mt-1">
                                        <small v-if="passwordForm.password === passwordForm.password_confirmation" class="text-success">
                                            <i class="bi bi-check-circle me-1"></i>Passwords match
                                        </small>
                                        <small v-else class="text-danger">
                                            <i class="bi bi-x-circle me-1"></i>Passwords do not match
                                        </small>
                                    </div>

                                    <div v-if="passwordForm.errors.password_confirmation" class="invalid-feedback">
                                        {{ passwordForm.errors.password_confirmation }}
                                    </div>
                                </div>

                                <button type="submit" :disabled="passwordForm.processing || !passwordForm.current_password || passwordForm.password.length < 8 || passwordForm.password !== passwordForm.password_confirmation" class="btn btn-warning">
                                    <span v-if="passwordForm.processing">
                                        <i class="bi bi-arrow-repeat spinning me-2"></i>Updating Password...
                                    </span>
                                    <span v-else>
                                        <i class="bi bi-shield-lock me-2"></i>Update Password
                                    </span>
                                </button>

                                <!-- Show requirements -->
                                <div class="mt-3">
                                    <small class="text-muted">
                                        <strong>Password Requirements:</strong>
                                    </small>
                                    <ul class="small text-muted mt-1 mb-0">
                                        <li :class="passwordRequirements.length ? 'text-success' : ''">
                                            <i :class="passwordRequirements.length ? 'bi bi-check-circle' : 'bi bi-circle'" class="me-1"></i>
                                            At least 8 characters
                                        </li>
                                        <li :class="passwordRequirements.lowercase ? 'text-success' : ''">
                                            <i :class="passwordRequirements.lowercase ? 'bi bi-check-circle' : 'bi bi-circle'" class="me-1"></i>
                                            One lowercase letter
                                        </li>
                                        <li :class="passwordRequirements.uppercase ? 'text-success' : ''">
                                            <i :class="passwordRequirements.uppercase ? 'bi bi-check-circle' : 'bi bi-circle'" class="me-1"></i>
                                            One uppercase letter
                                        </li>
                                        <li :class="passwordRequirements.numbers ? 'text-success' : ''">
                                            <i :class="passwordRequirements.numbers ? 'bi bi-check-circle' : 'bi bi-circle'" class="me-1"></i>
                                            One number
                                        </li>
                                        <li :class="passwordRequirements.special ? 'text-success' : ''">
                                            <i :class="passwordRequirements.special ? 'bi bi-check-circle' : 'bi bi-circle'" class="me-1"></i>
                                            One special character
                                        </li>
                                    </ul>
                                </div>
                            </form>
                        </div>
                    </div>

                    <!-- Security Settings -->
                    <div class="card mb-4 d-none">
                        <div class="card-header">
                            <h5 class="mb-0">Security Settings</h5>
                        </div>
                        <div class="card-body">
                            <div class="security-item mb-3">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 class="mb-1">Two-Factor Authentication</h6>
                                        <small class="text-muted">Add an extra layer of security</small>
                                    </div>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="mfa" checked>
                                    </div>
                                </div>
                            </div>

                            <div class="security-item mb-3">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 class="mb-1">Email Notifications</h6>
                                        <small class="text-muted">Security alerts and updates</small>
                                    </div>
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" id="emailNotifs" checked>
                                    </div>
                                </div>
                            </div>

                            <div class="d-grid gap-2 mt-3">
                                <button class="btn btn-outline-warning btn-sm">
                                    <i class="bi bi-key me-2"></i>Change Password
                                </button>
                                <button class="btn btn-outline-info btn-sm">
                                    <i class="bi bi-shield-lock me-2"></i>Security Log
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Quick Actions -->
                    <div class="card d-none">
                        <div class="card-header">
                            <h5 class="mb-0">Quick Actions</h5>
                        </div>
                        <div class="card-body">
                            <div class="d-grid gap-2">
                                <button class="btn btn-success btn-sm">
                                    <i class="bi bi-share me-2"></i>Share Profile
                                </button>
                                <button class="btn btn-info btn-sm">
                                    <i class="bi bi-printer me-2"></i>Print Profile
                                </button>
                                <button class="btn btn-outline-danger btn-sm">
                                    <i class="bi bi-trash me-2"></i>Delete Account
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>



<script setup>
import AppLayout from '../Layouts/AppLayout.vue';
import { computed, ref, onMounted } from 'vue';
import { usePage, useForm, router } from '@inertiajs/vue3';
import { useNotifications } from '@/composables/useNotifications';

// Get page props
const page = usePage();

// Initialize notifications
const { success, error, warning, info } = useNotifications();

// Check if user is authenticated
const isAuthenticated = computed(() => {
    return !!page.props.auth.user;
});

// Get authenticated user
const user = computed(() => {
    return page.props.auth.user;
});

// Get certifications data
const certifications = computed(() => {
    return page.props.certifications || [];
});

// Certification management state
const isEditingCertification = ref(false);
const showCertificationForm = ref(false);
const certificationTemplates = ref([]);

// Certification form
const certificationForm = useForm({
    name: '',
    full_name: '',
    issuing_organization: '',
    certification_number: '',
    issued_date: '',
    expiry_date: '',
    description: '',
    status: 'active',
    icon_class: 'bi bi-award',
    color: 'primary'
});

// Password strength indicator
const passwordStrength = computed(() => {
    const password = passwordForm.password;
    if (!password) return { strength: 0, text: '', color: '' };

    let score = 0;
    const checks = {
        length: password.length >= 8,
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        numbers: /\d/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };

    score = Object.values(checks).filter(Boolean).length;

    if (score <= 2) return { strength: score, text: 'Weak', color: 'danger' };
    if (score <= 3) return { strength: score, text: 'Fair', color: 'warning' };
    if (score <= 4) return { strength: score, text: 'Good', color: 'info' };
    return { strength: score, text: 'Strong', color: 'success' };
});

// Password requirements checker
const passwordRequirements = computed(() => {
    const password = passwordForm.password;
    return {
        length: password.length >= 8,
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        numbers: /\d/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };
});

// Edit mode state
const isEditMode = ref(false);

// Form for updating profile
const form = useForm({
    first_name: user.value?.first_name || '',
    last_name: user.value?.last_name || '',
    phone: user.value?.phone || '',
    professional_title: user.value?.professional_title || '',
    company: user.value?.company || '',
    bio: user.value?.bio || '',
    country: user.value?.country || '',
    address: user.value?.address || '',
    city: user.value?.city || '',
    postal_code: user.value?.postal_code || '',
    id_number: user.value?.id_number || '',
    profession: user.value?.profession || '',
});

// Password update form
const passwordForm = useForm({
    current_password: '',
    password: '',
    password_confirmation: '',
});

// Load certification templates on mount
onMounted(async () => {
    try {
        const response = await fetch('/certifications/templates');
        if (response.ok) {
            certificationTemplates.value = await response.json();
        }
    } catch (err) {
        console.log('Failed to load certification templates');
    }
});

// Certification form functions
const openAddCertificationForm = () => {
    console.log('Opening certification form');
    isEditingCertification.value = false;
    certificationForm.reset();
    certificationForm.clearErrors();
    showCertificationForm.value = true;
    console.log('Form should be visible now:', showCertificationForm.value);
};

const editCertification = (certification) => {
    console.log('Editing certification:', certification);
    isEditingCertification.value = true;
    certificationForm.reset();
    certificationForm.clearErrors();

    // Fill form with certification data
    certificationForm.name = certification.name || '';
    certificationForm.full_name = certification.full_name || '';
    certificationForm.issuing_organization = certification.issuing_organization || '';
    certificationForm.certification_number = certification.certification_number || '';
    certificationForm.description = certification.description || '';
    certificationForm.status = certification.status || 'active';
    certificationForm.icon_class = certification.icon_class || 'bi bi-award';
    certificationForm.color = certification.color || 'primary';

    // Format dates for date inputs (YYYY-MM-DD)
    if (certification.issued_date) {
        // Extract date part from ISO format (e.g., "2025-10-15T00:00:00.000000Z" -> "2025-10-15")
        const issuedDate = certification.issued_date.split('T')[0];
        certificationForm.issued_date = issuedDate;
        console.log('Set issued_date to:', issuedDate);
    }
    if (certification.expiry_date) {
        // Extract date part from ISO format (e.g., "2026-11-29T00:00:00.000000Z" -> "2026-11-29")
        const expiryDate = certification.expiry_date.split('T')[0];
        certificationForm.expiry_date = expiryDate;
        console.log('Set expiry_date to:', expiryDate);
    }

    // Store the certification ID for updating
    certificationForm.id = certification.id;

    console.log('Form data after setting:', certificationForm.data());
    showCertificationForm.value = true;
};

const closeCertificationForm = () => {
    showCertificationForm.value = false;
    certificationForm.reset();
    certificationForm.clearErrors();
};

const saveCertification = () => {
    if (isEditingCertification.value) {
        // Update existing certification
        certificationForm.patch(`/certifications/${certificationForm.id}`, {
            onSuccess: () => {
                success('Certification updated successfully!');
                closeCertificationForm();
                // Refresh the page data
                router.reload({ only: ['certifications'] });
            },
            onError: () => {
                error('Failed to update certification. Please try again.');
            }
        });
    } else {
        // Create new certification
        certificationForm.post('/certifications', {
            onSuccess: () => {
                success('Certification added successfully!');
                closeCertificationForm();
                // Refresh the page data
                router.reload({ only: ['certifications'] });
            },
            onError: () => {
                error('Failed to add certification. Please try again.');
            }
        });
    }
};

const deleteCertification = (certificationId) => {
    if (confirm('Are you sure you want to delete this certification? This action cannot be undone.')) {
        router.delete(`/certifications/${certificationId}`, {
            onSuccess: () => {
                success('Certification deleted successfully!');
                router.reload({ only: ['certifications'] });
            },
            onError: () => {
                error('Failed to delete certification. Please try again.');
            }
        });
    }
};

const applyCertificationTemplate = (template) => {
    certificationForm.name = template.name;
    certificationForm.full_name = template.full_name || template.name;
    certificationForm.issuing_organization = template.organization;
    certificationForm.description = template.description || '';

    // Focus on issue date field
    setTimeout(() => {
        document.getElementById('issuedDate')?.focus();
    }, 100);
};

// Utility function to format dates
const formatDate = (dateString) => {
    if (!dateString) return '';

    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch (e) {
        return dateString;
    }
};

// Toggle edit mode
const toggleEditMode = () => {
    if (isEditMode.value) {
        // Reset form to original values when canceling
        resetForm();
    }
    isEditMode.value = !isEditMode.value;
};

// Reset form to original values
const resetForm = () => {
    form.reset();
    form.clearErrors();
};

// Update profile
const updateProfile = () => {
    form.patch('/profile', {
        onSuccess: () => {
            isEditMode.value = false;
            success('Profile updated successfully!');
        },
        onError: () => {
            error('There was an error updating your profile. Please try again.');
        },
    });
};

// Update password
const updatePassword = () => {
    // Client-side validation
    if (passwordForm.password !== passwordForm.password_confirmation) {
        passwordForm.setError('password_confirmation', 'Passwords do not match.');
        warning('Passwords do not match!');
        return;
    }

    if (passwordForm.password.length < 8) {
        passwordForm.setError('password', 'Password must be at least 8 characters long.');
        warning('Password must be at least 8 characters long!');
        return;
    }

    passwordForm.patch('/profile/password', {
        onSuccess: () => {
            passwordForm.reset();
            success('Password updated successfully! Your account is now more secure.');
            // Auto-hide success message after 5 seconds
            setTimeout(() => {
                passwordForm.recentlySuccessful = false;
            }, 5000);

        },
        onError: () => {
            // Keep form data but clear passwords for security
            passwordForm.current_password = '';
            passwordForm.password = '';
            passwordForm.password_confirmation = '';
            error('There was an error updating your password. Please check your current password and try again.');
        },
    });
};

console.log('User data:', user.value);
console.log('Certifications:', certifications.value);
</script>

<style scoped>
#profile-header-section {
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    color: white;
    padding: 3rem 0;
    margin-bottom: 2rem;
}

/* Profile Header */
.profile-header {
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    color: white;
    border: none;
    border-radius: 15px;
}

.profile-avatar img {
    width: 120px;
    height: 120px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    object-fit: cover;
}

.profile-info h2 {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.profile-badges .badge {
    font-size: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 20px;
}

.profile-stats .stat-item {
    text-align: center;
}

.profile-stats .stat-item strong {
    font-size: 1.5rem;
    font-weight: 700;
    color: white;
}

.profile-stats .stat-item small {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.8rem;
}

/* Card Styling */
.card {
    border: 1px solid #e9ecef;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
}

.card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    border-radius: 12px 12px 0 0 !important;
    padding: 1rem 1.25rem;
}

.card-header h5 {
    font-weight: 600;
    color: #2c3e50;
}

/* Form Styling */
.form-control[readonly] {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    color: #495057;
}

.form-control:focus {
    border-color: #1e9579;
    box-shadow: 0 0 0 0.2rem rgba(30, 149, 121, 0.25);
}

.form-label {
    font-weight: 500;
    color: #495057;
    margin-bottom: 0.5rem;
}

/* Certification Grid */
.certification-grid {
    display: grid;
    gap: 1rem;
}

.certification-item {
    display: flex;
    align-items: center;
    padding: 1rem;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    transition: all 0.3s ease;
}

.certification-item:hover {
    border-color: #1e9579;
    box-shadow: 0 2px 8px rgba(30, 149, 121, 0.15);
    transform: translateY(-1px);
}

.cert-icon {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 1rem;
    font-size: 1.5rem;
    color: white;
}

.cert-details h6 {
    font-weight: 600;
    color: #2c3e50;
}

.cert-details small {
    color: #6c757d;
    display: block;
}

.cert-date {
    font-size: 0.8rem;
    color: #28a745;
    font-weight: 500;
    margin-top: 0.25rem;
}

.cert-actions {
    margin-top: 0.5rem;
}

.cert-actions .btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
}

/* Skills Section */
.skills-container .skill-item {
    margin-bottom: 1rem;
}

.skills-container .skill-item:last-child {
    margin-bottom: 0;
}

.progress {
    height: 8px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #f0f0f0;
}

.progress-bar {
    border-radius: 10px;
    transition: width 0.6s ease;
}

/* CV Upload Area */
.cv-upload-area {
    padding: 2rem 1rem;
    border: 2px dashed #e9ecef;
    border-radius: 10px;
    transition: all 0.3s ease;
}

.cv-upload-area:hover {
    border-color: #1e9579;
    background-color: rgba(30, 149, 121, 0.05);
}

.cv-upload-area h6 {
    font-weight: 600;
    color: #2c3e50;
}

/* Security Settings */
.security-item {
    padding: 0.75rem 0;
    border-bottom: 1px solid #f0f0f0;
}

.security-item:last-child {
    border-bottom: none;
}

.security-item h6 {
    font-weight: 500;
    color: #2c3e50;
}

.form-check-input:checked {
    background-color: #28a745;
    border-color: #28a745;
}

.form-check-input:focus {
    border-color: #28a745;
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

/* Button Styling */
.btn {
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-sm {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
}

/* Responsive Design */
@media (max-width: 768px) {
    .profile-header .card-body .row {
        text-align: center;
    }

    .profile-stats {
        justify-content: center;
        margin-top: 1rem;
    }

    .certification-item {
        flex-direction: column;
        text-align: center;
    }

    .cert-icon {
        margin-right: 0;
        margin-bottom: 1rem;
    }

    .profile-avatar img {
        width: 100px;
        height: 100px;
    }
}

/* Badge Colors */
.bg-primary {
    background-color: #1e9579 !important;
}

.bg-success {
    background-color: #28a745 !important;
}

.bg-info {
    background-color: #17a2b8 !important;
}

.bg-warning {
    background-color: #ffc107 !important;
}

/* Text Colors */
.text-primary {
    color: #1e9579 !important;
}

.text-success {
    color: #28a745 !important;
}

.text-info {
    color: #17a2b8 !important;
}

.text-warning {
    color: #ffc107 !important;
}

/* Animations */
.spinning {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* Form States */
.form-control[readonly] {
    background-color: #f8f9fa;
    opacity: 0.8;
}

.form-control.is-invalid {
    border-color: #dc3545;
}

.form-control.is-invalid:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.invalid-feedback {
    display: block;
}

/* Button States */
.btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* Alert Styling */
.alert {
    border-radius: 8px;
    border: none;
}

.alert-success {
    background-color: #d4edda;
    color: #155724;
}

/* Certification Modal */
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
}

.modal-dialog {
    background: white;
    border-radius: 15px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    max-width: 800px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
}

.modal-content {
    border: none;
    border-radius: 15px;
}

.modal-header {
    border-bottom: 1px solid #f0f0f0;
    background-color: #f8f9fa;
    border-radius: 15px 15px 0 0;
    padding: 1rem 1.5rem;
}

.modal-title {
    font-weight: 600;
    color: #2c3e50;
}

.btn-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    font-weight: bold;
    color: #6c757d;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-close:hover {
    color: #dc3545;
}

.modal-body {
    padding: 1.5rem;
}

.modal-footer {
    border-top: 1px solid #f0f0f0;
    background-color: #f8f9fa;
    border-radius: 0 0 15px 15px;
    padding: 1rem 1.5rem;
}

/* Template Cards */
.template-card {
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid #e9ecef;
    border-radius: 8px;
}

.template-card:hover {
    border-color: #1e9579;
    background-color: rgba(30, 149, 121, 0.05);
    transform: translateY(-2px);
}

.template-icon {
    font-size: 1.25rem;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.05);
}

/* Danger text color */
.text-danger {
    color: #dc3545 !important;
}
</style>
